import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import { useSelectorNonNullable } from 'src/hooks/useSelector';
import { EmployerStateType } from 'src/models/negotiationTopic.types';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    added: 'negotiations.employer.added',
    [EmployerStateType.Invitation]: 'negotiations.employer.invited',
    [EmployerStateType.Response]: 'negotiations.employer.responded',
};

interface Props {
    topicId: string;
    isSmall?: boolean;
}

const FirstContactTime: TranslatedComponent<Props> = ({ topicId, trls }) => {
    const topic = useSelectorNonNullable((state) => state.candidatesList.shortTopicList?.topicList[topicId]);

    if (!topic) {
        return null;
    }

    const { initialState: topicState, creationTime } = topic;
    const text =
        topicState === EmployerStateType.Invitation || topicState === EmployerStateType.Response
            ? trls[TrlKeys[topicState]]
            : trls[TrlKeys.added];

    return (
        <span>
            {text}
            {REGULAR_SPACE}
            <HumanDate date={Number(creationTime)} showYear={ShowYear.NotCurrent} />
        </span>
    );
};

export default translation(FirstContactTime);
